import { Box, Card, Typography, Grid, TextField, MenuItem, Button, IconButton } from '@mui/material'
import React, { useState, useEffect } from 'react'
import Header from '../Header'
import { styles } from '../../styles/styles';
import { DecorativeCorner } from '../../common/DecorativeCorner';
import { useLocation } from 'react-router-dom';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import SearchIcon from "@mui/icons-material/Search";
import Footer from '../Footer';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SearchProfile = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const quickdetalies = location.state?.click;
    const advancedlocation = location.state?.AdvancedSearch;
    const serachbyidlocationfetch = location.state?.IDSearch;
    const [quick, setQuick] = useState(false);
    const [advanced, setAdvanced] = useState(false);
    const [idsearch, setIdSearch] = useState(false);

    const [clickedButton, setClickedButton] = useState(null);

    useEffect(() => {
        if (quickdetalies === "Search") {
            setQuick(true);
            setClickedButton("Quick Search");
        }
    }, [quickdetalies]);

    useEffect(() => {
        if (advancedlocation === "Search") {
            setAdvanced(true);
            setClickedButton("Advanced Search");
        }
    }, [advancedlocation]);

    useEffect(() => {
        if (serachbyidlocationfetch === "Search") {
            setIdSearch(true);
            setClickedButton("ID Search");
        }
    }, [serachbyidlocationfetch]);

    const handleClick = (button) => {
        setClickedButton(button);
        setQuick(button === "Quick Search");
        setAdvanced(button === "Advanced Search");
        setIdSearch(button === "ID Search");
    };
    const [selectedOption, setSelectedOption] = useState({
        toheight: "",
        fromheight: "",
        toage: "",
        fromage: "",
        MaritalStatus: "",
        Country: "",
        State: "",
        city: "",
        Education: "",
        Profession: "",
        AnnualIncome: "",
        MotherTongue: "",
        Smoke: "",
        Drink: "",
        Complexion: "",
    });

    const [isOpen, setIsOpen] = useState({});

    const handleChangeAdvance = (e) => {
        const { name, value } = e.target;
        setSelectedOption((prev) => ({
            ...prev,
            [name]: value,
        }));
        setIsOpen((prev) => ({ ...prev, [name]: false }));
    };

    const handleFocus = (name) => {
        setIsOpen((prev) => ({ ...prev, [name]: true }));
    };

    return (
        <Box>
            <Header />
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: { xs: "35%", sm: "10%" },
                    gap: "20px",
                    flexDirection: { xs: "column", sm: "row" },
                }}
            >
                <Button
                    onClick={() => navigate("/profile/DetaliesDashbord?type=suggested-profiles")}
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        color: "inherit",
                        "&:hover": {
                            backgroundColor: "rgb(224, 141, 64)",
                            color: "white"
                        }
                    }}
                >
                    <ArrowBackIcon />
                    <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                        }}
                    >
                        Back
                    </Typography>
                </Button>

                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: clickedButton === "Quick Search" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Quick Search" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("Quick Search")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Quick Search
                    </Typography>
                </Card>

                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        border: "2px solid rgb(226, 122, 24)",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        backgroundColor: clickedButton === "Advanced Search" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "Advanced Search" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff", border: "1px solid rgb(224, 141, 64)" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff", },
                    }}
                    onClick={() => handleClick("Advanced Search")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        Advanced Search
                    </Typography>
                </Card>

                <Card
                    sx={{
                        padding: "8.55px",
                        borderRadius: "854.41px",
                        width: "307px",
                        height: "112.89px",
                        gap: "8.55px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        border: "2px solid rgb(226, 122, 24)",

                        backgroundColor: clickedButton === "ID Search" ? "rgb(224, 141, 64)" : "#fff",
                        color: clickedButton === "ID Search" ? "#fff" : "inherit",
                        "&:hover": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                        "&:active": { backgroundColor: "rgb(224, 141, 64)", color: "#fff" },
                    }}
                    onClick={() => handleClick("ID Search")}
                >
                    <Typography sx={{ fontFamily: "SF Pro Display, sans-serif", fontWeight: 700, fontSize: "27.37px", cursor: "pointer" }}>
                        ID Search
                    </Typography>
                </Card>
            </Box>;
            {
                quick && (
                    <Card
                        sx={{
                            ...styles.cardsuggetion,
                            marginTop: { xs: "10%", sm: "2%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Box
                            sx={{
                                width: "100%",
                                padding: { xs: "15px", sm: "30px" },
                                backgroundColor: "white",
                                height: "auto",
                                border: "2px solid rgb(224, 141, 64)",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                            }}
                        >
                            <Grid container spacing={2}>
                                {[
                                    { name: "fromage", label: "From Age", options: ["18", "20", "30", "40", "50"] },
                                    { name: "toage", label: "To Age", options: ["18", "20", "30", "40", "50"] },
                                    { name: "fromheight", label: "From Height", options: ["4ft", "5ft", "6ft", "7ft", "8ft", "9ft"] },
                                    { name: "toheight", label: "To Height", options: ["4ft", "5ft", "6ft", "7ft", "8ft", "9ft"] },
                                    { name: "MaritalStatus", label: "Marital Status", options: ["Single", "Married", "Divorced", "Widowed"] },
                                    { name: "Country", label: "Country", options: ["India", "USA", "UK", "Canada"] },
                                    { name: "city", label: "City", options: ["New York", "Delhi", "London", "Vancouver"] },
                                    { name: "State", label: "State", options: ["California", "New York", "Florida", "Ontario"] },
                                ].map((field, index) => (
                                    <Grid key={index} item xs={12} sm={6} sx={{ position: "relative" }}>
                                        <select
                                            name={field.name}
                                            value={selectedOption[field.name]}
                                            onChange={handleChangeAdvance}
                                            onFocus={() => handleFocus(field.name)}
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                fontSize: "16px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "white",
                                                outline: "none",
                                                cursor: "pointer",
                                                appearance: "none",
                                                height: "50px"
                                            }}
                                        >
                                            <option value="">{field.label}</option>
                                            {field.options.map((option, idx) => (
                                                <option key={idx} value={option}>{option}</option>
                                            ))}
                                        </select>
                                        <span
                                            style={{
                                                position: "absolute",
                                                top: "70%",
                                                right: "12px",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                                fontSize: "20px",
                                                color: "#555",
                                            }}
                                        >
                                            {isOpen[field.name] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </span>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                        <Box sx={{ display: "flex", margin: "10px", gap: "20px" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#fff",
                                    color: "rgb(183, 113, 8)",
                                    borderRadius: "50px",
                                    border: "2px solid rgb(200, 147, 69)",
                                    padding: { xs: "8px 12px", sm: "15px 25px" },
                                    fontSize: { xs: "12px", sm: "14px" },
                                }}

                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "rgb(183, 113, 8)",
                                    color: "white",
                                    borderRadius: "50px",
                                    padding: { xs: "8px 12px", sm: "15px 25px" },
                                    fontSize: { xs: "12px", sm: "14px" },
                                }}
                            >
                                Search
                            </Button>
                        </Box>
                    </Card>
                )
            }
            {
                advanced && (
                    <Card
                        sx={{
                            ...styles.cardsuggetion,
                            marginTop: { xs: "10%", sm: "2%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Box
                            sx={{
                                width: "100%",
                                padding: { xs: "15px", sm: "30px" },
                                backgroundColor: "white",
                                height: "auto",
                                border: "2px solid rgb(224, 141, 64)",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                            }}
                        >
                            <Grid container spacing={2}>
                                {[
                                    { name: "fromage", label: "From Age", options: ["18", "20", "30", "40", "50"] },
                                    { name: "toage", label: "To Age", options: ["18", "20", "30", "40", "50"] },
                                    { name: "fromheight", label: "From Height", options: ["4ft", "5ft", "6ft", "7ft", "8ft", "9ft"] },
                                    { name: "toheight", label: "To Height", options: ["4ft", "5ft", "6ft", "7ft", "8ft", "9ft"] },
                                    { name: "MaritalStatus", label: "Marital Status", options: ["Single", "Married", "Divorced", "Widowed"] },
                                    { name: "Country", label: "Country", options: ["India", "USA", "UK", "Canada"] },
                                    { name: "State", label: "State", options: ["California", "New York", "Florida", "Ontario"] },
                                    { name: "Education", label: "Education", options: [" Degree", "Diploma", "mbbs"] },
                                    { name: " Profession", label: "Profession", options: ["doctor", "loyar", "software"] },
                                    { name: " AnnualIncome", label: "AnnualIncome", options: ["₹3L per year", "5L per year", "10l per year"] },
                                    { name: " MotherTongue", label: " MotherTongue", options: ["Telugu", "Tamil", "Kannada", "hindi",] },
                                    { name: "Smoke", label: "Smoke", options: ["No", "Yes"] },
                                    { name: "Drink", label: "Drink", options: ["No", "Yes"] },
                                    { Complexion: "Complexion", label: "Complexion", options: ["No", "Yes"] }
                                ].map((field, index) => (
                                    <Grid key={index} item xs={12} sm={6} sx={{ position: "relative" }}>
                                        <select
                                            name={field.name}
                                            value={selectedOption[field.name]}
                                            onChange={handleChangeAdvance}
                                            onFocus={() => handleFocus(field.name)}
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                fontSize: "16px",
                                                borderRadius: "5px",
                                                border: "1px solid #ccc",
                                                backgroundColor: "white",
                                                outline: "none",
                                                cursor: "pointer",
                                                appearance: "none",
                                                height: "50px"
                                            }}
                                        >
                                            <option value="">{field.label}</option>
                                            {field.options.map((option, idx) => (
                                                <option key={idx} value={option}>{option}</option>
                                            ))}
                                        </select>
                                        <span
                                            style={{
                                                position: "absolute",
                                                top: "70%",
                                                right: "12px",
                                                transform: "translateY(-50%)",
                                                pointerEvents: "none",
                                                fontSize: "20px",
                                                color: "#555",
                                            }}
                                        >
                                            {isOpen[field.name] ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                        </span>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                        <Box sx={{ display: "flex", margin: "10px", gap: "20px" }}>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "#fff",
                                    color: "rgb(183, 113, 8)",
                                    borderRadius: "50px",
                                    border: "2px solid rgb(200, 147, 69)",
                                    padding: { xs: "8px 12px", sm: "15px 25px" },
                                    fontSize: { xs: "12px", sm: "14px" },
                                }}
                                onClick={() => setAdvanced(false)}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                sx={{
                                    backgroundColor: "rgb(183, 113, 8)",
                                    color: "white",
                                    borderRadius: "50px",
                                    padding: { xs: "8px 12px", sm: "15px 25px" },
                                    fontSize: { xs: "12px", sm: "14px" },
                                }}
                            >
                                Search
                            </Button>
                        </Box>
                    </Card>
                )
            }
            {
                idsearch && (
                    <Card
                        sx={{
                            ...styles.cardsuggetion,
                            marginTop: { xs: "10%", sm: "3%" },
                            height: "100%",
                            padding: { xs: "10%", sm: "40px" },
                        }}
                    >
                        <DecorativeCorner sx={{ top: -20, left: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ top: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, right: -20, transform: "rotate(0deg)" }} />
                        <DecorativeCorner sx={{ bottom: -20, left: -20, transform: "rotate(0deg)" }} />
                        <Box
                            sx={{
                                width: "100%",
                                padding: { xs: "15px", sm: "30px" },
                                backgroundColor: "white",
                                height: "auto",
                                border: "2px solid rgb(224, 141, 64)",
                                boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                borderRadius: "8px",
                            }}
                        >
                            <Grid container spacing={2}>
                                <Grid
                                    item xs={12} sm={12}
                                    sx={{
                                        display: "flex",
                                        flexDirection: { xs: "column", sm: "row" },
                                        gap: "10px",
                                        alignItems: "center",
                                        justifyContent: { xs: "center", sm: "flex-start" },
                                    }}
                                >
                                    <TextField fullWidth />
                                    <Button
                                        variant="contained"
                                        sx={{
                                            backgroundColor: "rgb(183, 113, 8)",
                                            color: "white",
                                            borderRadius: "4px",
                                            width: "150px",
                                            height: "52px",
                                            fontFamily: "Roboto",
                                            padding: { xs: "8px 12px", sm: "10px 4px" },
                                            fontSize: { xs: "12px", sm: "18px" },
                                        }}
                                        startIcon={<SearchIcon sx={{ color: "white" }} />}
                                    >
                                        Search
                                    </Button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Card>
                )
            }
            <Footer />
        </Box>
    )
}

export default SearchProfile
